var _style, _path, _path2, _defs, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAltItemActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:none;stroke:#000000;stroke-opacity:0.2;}\n\t.st2{clip-path:url(#SVGID_00000119828788367736442440000009714081966329708195_);}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30,0L30,0c16.6,0,30,13.4,30,30l0,0c0,16.6-13.4,30-30,30l0,0C13.4,60,0,46.6,0,30l0,0C0,13.4,13.4,0,30,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30,0.5L30,0.5c16.3,0,29.5,13.2,29.5,29.5l0,0c0,16.3-13.2,29.5-29.5,29.5l0,0C13.7,59.5,0.5,46.3,0.5,30l0,0 C0.5,13.7,13.7,0.5,30,0.5z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 15,
    y: 15.4,
    width: 30,
    height: 30
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000129918943358281973930000007101629181258618039_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000129918943358281973930000007101629181258618039_)"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15.4c-4,0-7.8,1.6-10.6,4.4c-2.8,2.8-4.4,6.6-4.4,10.6c0,4,1.6,7.8,4.4,10.6c2.8,2.8,6.6,4.4,10.6,4.4 c2.6,0,5.2-0.7,7.5-2c2.3-1.3,4.2-3.2,5.5-5.5c1.3-2.3,2-4.9,2-7.5c0-4-1.6-7.8-4.4-10.6C37.8,17,34,15.4,30,15.4L30,15.4z  M37.5,30.4c0,0.3-0.1,0.6-0.4,0.9l-4.9,4.9c-0.3,0.3-0.7,0.4-1.2,0.3c-0.4-0.1-0.7-0.4-0.9-0.9c-0.1-0.4,0-0.9,0.3-1.2l2.9-2.9 h-9.7c-0.4,0-0.8-0.2-1-0.6c-0.2-0.4-0.2-0.8,0-1.2c0.2-0.4,0.6-0.6,1-0.6h9.7l-2.9-2.9h0c-0.3-0.3-0.4-0.8-0.3-1.2 c0.1-0.4,0.4-0.7,0.9-0.9c0.4-0.1,0.9,0,1.2,0.3l4.9,4.9C37.4,29.7,37.5,30,37.5,30.4L37.5,30.4z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAltItemActive);
export default __webpack_public_path__ + "static/media/alt_item_active.d6fff1112f996ceaedcef8a5dbe69310.svg";
export { ForwardRef as ReactComponent };